import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattingTool } from "./types";

interface ToolbarButtonProps {
    tool: FormattingTool;
    active: boolean;
    onClick: () => void;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({ tool, active, onClick }) => (
    <button
        type="button"
        className={`note-formatting-toolbar-button ${active ? "active" : ""}`}
        aria-label={tool.ariaLabel}
        aria-pressed={active}
        title={tool.ariaLabel}
        onMouseDown={(event) => event.preventDefault()}
        onClick={onClick}
    >
        <FontAwesomeIcon icon={tool.icon} />
    </button>
);
